"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
const to_date_time_string_1 = require("./utils/to-date-time-string");
class MetricsClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super();
        this.executor.setFormatDateWithTimezone(true);
    }
    getMetric(projectId, body) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/metrics`, body);
            return response.payload;
        });
    }
    getHistogram(projectId, body) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/metrics/chart`, body);
            return response.payload;
        });
    }
    getDashboardMetrics(ac) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${ac.project}/metrics/dashboard?from=${(0, to_date_time_string_1.toDateTimeString)(ac.from)}&to=${(0, to_date_time_string_1.toDateTimeString)(ac.to)}` +
                `&goal=${ac.goal}&segments=${ac.segments.join(',')}&segmentInclude=${ac.segmentInclude}&device=${ac.device}&toCurrency=${ac.toCurrency}`;
            const response = yield this.httpGet(url);
            response.payload.conversions.forEach((i) => (i.date = new Date(i.date)));
            return response.payload;
        });
    }
    getPagesMetrics(ac) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { project, from, to, device, pages, metrics, goal, includeSegmentIds, excludeSegmentIds } = ac;
            const req = { project, from, to, device, pages, metrics, goal, includeSegmentIds, excludeSegmentIds };
            const url = `/v1/projects/${ac.project}/metrics/pages?` + this.getQueryString(req);
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getExposures(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { project, from, to, device, page, goal, segments, segmentInclude, midZoneHeights } = request;
            const req = { project, from, to, device, page, goal, segments, segmentInclude, midZoneHeights };
            const url = `/v1/projects/${req.project}/metrics/exposures?` + this.getQueryString(req);
            const response = yield this.httpGet(url);
            if (Array.isArray(midZoneHeights)) {
                return response.payload;
            }
            return response.payload[0];
        });
    }
    getZoningMetrics(payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${payload.project}/metrics/zoning`;
            const response = yield this.httpPost(url, payload);
            return response.payload || [];
        });
    }
    getZonesMetrics(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = Array.isArray(request.metrics) ? { metrics: request.metrics } : { metricType: request.metrics };
            const url = `/v1/projects/${request.project}/metrics/zones?` + this.getQueryString(queryString);
            const response = yield this.httpPost(url, Object.assign(Object.assign({}, request), { metrics: undefined }));
            return response.payload;
        });
    }
    getPageViews(payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { project } = payload, params = tslib_1.__rest(payload, ["project"]);
            const url = `/v1/projects/${project}/metrics/total-views`;
            const response = yield this.httpPost(url, params);
            return {
                pageId: payload.pageId || payload.aliasId,
                urlRegex: payload.urlRegex,
                totalViews: response.payload ? response.payload.totalViews : null,
            };
        });
    }
    getUrlsMetricsList(payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { project } = payload, params = tslib_1.__rest(payload, ["project"]);
            const url = `/v1/projects/${project}/metrics/urls`;
            const response = yield this.httpPost(url, params);
            return response.payload || [];
        });
    }
    getPageMetrics(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${request.project}/metrics/page?from=${(0, to_date_time_string_1.toDateTimeString)(request.from)}` +
                `&to=${(0, to_date_time_string_1.toDateTimeString)(request.to)}&device=${request.device}&segments=${request.segments.join(',')}` +
                `&segmentInclude=${request.segmentInclude}&page=${request.page}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getFoldHeight(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const segments = request.segments && request.segments.length ? request.segments : [-1];
            const segmentInclude = request.segmentInclude === false ? false : true;
            const url = `/v1/projects/${request.project}/metrics/foldheight?from=${(0, to_date_time_string_1.toDateTimeString)(request.from)}` +
                `&to=${(0, to_date_time_string_1.toDateTimeString)(request.to)}&device=${request.device}&segments=${segments.join(',')}` +
                `&page=${request.page}&segmentInclude=${segmentInclude}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getNavigationTree(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${request.project}/metrics/navigation-path?` +
                this.getQueryString(Object.assign(Object.assign({}, request), { projects: undefined }));
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
}
exports.MetricsClient = MetricsClient;
//# sourceMappingURL=metrics.client.js.map